import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user-service/user.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-users-user-dashboard',
  templateUrl: './users-user-dashboard.component.html',
  styleUrls: ['./users-user-dashboard.component.scss']
})
export class UsersUserDashboardComponent implements OnInit, OnDestroy {

  user;
  getUserSubscriptionRefresh: Subscription;
  getUserInfoSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService,
              private userService: UserService) { }

  ngOnInit() {
    this.getUserSubscriptionRefresh = this.userService.refreshUserListen().subscribe(
      (res) => {
        this.getUserInfo();
      }
    );
    this.setBreadcrumb();
    this.getUserInfo();
  }

  public getUserInfo() {
    const internalId = this.activatedRoute.snapshot.params['userid'];
    this.getUserInfoSubscription = this.userService.getUserInfo(internalId).subscribe(
      (res) => {
        this.user = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-user', 'users-page.user detail', '/account/users', [new BRoute('account-page.account', '/account'), new BRoute('users-page.users', '/account/users'), new BRoute('users-page.user detail')]));
  }

  ngOnDestroy() {
    if (this.getUserInfoSubscription) { this.getUserInfoSubscription.unsubscribe(); }
    if (this.getUserSubscriptionRefresh) { this.getUserSubscriptionRefresh.unsubscribe(); }
  }
}
